import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as PasswordSetupState } from "./redux";
import {
  selectHasUserAcceptedTnC,
  selectTnCForCidpUser,
} from "scenes/selectors";

/**
 * Direct selector to the passwordSetupPage state domain
 */

export const dashboardMfaSelector: (any) => PasswordSetupState = (state) =>
  state.mfa || initialState;

/**
 * Custom selectors to the passwordSetupPage state
 */
export const selectpasswordSetup = createSelector(
  dashboardMfaSelector,
  (substate) => substate
);
export const selectAppAuthenticators = createSelector(
  dashboardMfaSelector,
  (substate) => substate.authenticatorAppList
);

export const selectIsDashBoardMfaRedirectEnabled = createSelector(
  dashboardMfaSelector,
  (substate) => substate.isDashBoardMfaRedirectEnabled
);

export const selectCurrentStep = createSelector(
  dashboardMfaSelector,
  (substate) => substate.currentStep
);

export const selectIsAppAuthenticatorSetupDone = createSelector(
  dashboardMfaSelector,
  (substate) => substate.appAuthenticatorSetupDone
);

export const selectShowError = createSelector(
  dashboardMfaSelector,
  (substate) => substate.showError
);

export const selectLoading = createSelector(
  dashboardMfaSelector,
  (substate) => substate.loading
);

export const selectNoAuthenticators = createSelector(
  selectAppAuthenticators,
  (appAuthenticators) => {
    const enabledAppList = appAuthenticators.filter(
      (app) => app.enabled === true
    );
    return enabledAppList.length === 0;
  }
);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  authenticatorsInfo: selectAppAuthenticators,
  dashBoardRedirectInfo: selectIsDashBoardMfaRedirectEnabled,
  currentStep: selectCurrentStep,
  appAuthenticatorSetupDone: selectIsAppAuthenticatorSetupDone,
  showError: selectShowError,
  hasNoAuthenticators: selectNoAuthenticators,
  loading: selectLoading,
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
});
